<script lang="ts" setup>
const props = defineProps<{
    pager: Pager;
    space?: boolean;
}>();

const emit = defineEmits<{
    (e: 'change'): void;
}>();

const onChange = (): void => emit('change');
const cssClass = (mobile: boolean, phone: boolean): Record<string, boolean> =>
{
    return {
        'd-flex align-items-center mt-auto mb-0': true,
        'pt-3': props.space,
        'flex-wrap': mobile,
        'flex-nowrap': !mobile,
        'justify-content-start': mobile,
        'justify-content-between': !mobile
    };
};
</script>

<template>
    <div :class="cssClass(mobile, phone)">
        <Pagination :pager="props.pager" @change="onChange()" />
        <div class="d-flex align-items-center">
            <PaginationInfo :pager="props.pager" class="ms-2 d-none d-sm-block d-md-block d-lg-block text-nowrap" />
            <DataSize :pager="props.pager" class="ms-2" @change="onChange()" />
        </div>
    </div>
</template>
